import type { CloudflareImage, CloudflareVariantSize } from '~~/layers/base/types/printingProcess'

/**
 * Utility function for joining an aspect ration and size into a variant key
 */
export const getCloudflareImgVariant = (
    aspect: CloudflareImage['aspectRatio'],
    size: CloudflareVariantSize
) => `${aspect}${capitalize(size)}`
